import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { horasSoloDigitosValidator } from '../../../../shared/validators/horas-solo-digitos.validator';
import { PoliticaEntregaCellVm, PoliticaEntregaDetalleSaveValue } from '../../../../models/politica-entrega.vm';

type PoliticaEntregaDetalleForm = FormGroup<{
  incoterms: FormControl<string>;
  comuna: FormControl<string>;
  pallet: FormControl<string>;
  centro: FormControl<string>;
  horas: FormControl<string>;
}>;

@Component({
  selector: 'app-politica-entrega-detalle-modal',
  templateUrl: './politica-entrega-detalle-modal.component.html',
  styleUrls: ['./politica-entrega-detalle-modal.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PoliticaEntregaDetalleModalComponent implements OnChanges {
  @Input() cell: PoliticaEntregaCellVm | null = null;
  @Input() incoterms: string | null = null;
  @Input() loading = false;

  private readonly cdr = inject(ChangeDetectorRef);

  @Output() closeRequested = new EventEmitter<void>();
  @Output() saveRequested = new EventEmitter<PoliticaEntregaDetalleSaveValue>();
  @Output() deleteRequested = new EventEmitter<void>();

  readonly form: PoliticaEntregaDetalleForm;

  constructor(private readonly fb: FormBuilder) {
    this.form = this.fb.nonNullable.group({
      incoterms: this.fb.nonNullable.control(''),
      comuna: this.fb.nonNullable.control(''),
      pallet: this.fb.nonNullable.control(''),
      centro: this.fb.nonNullable.control('', { validators: [Validators.required] }),
      horas: this.fb.nonNullable.control('', {
        validators: [Validators.required, horasSoloDigitosValidator],
      }),
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['cell'] || changes['incoterms']) {
      this.patchForm();
    }
  }

  puedeEliminar(): boolean {
    return (this.cell?.id ?? 0) > 0;
  }

  mensajeErrorHoras(): string {
    const control = this.form.controls.horas;
    if (!control.touched || !control.invalid) {
      return '';
    }
    if (control.errors?.['required']) {
      return 'Campo requerido';
    }
    if (control.errors?.['horasSoloDigitos']) {
      return 'Ingrese solo números';
    }
    return '';
  }

  mensajeErrorCentro(): string {
    const control = this.form.controls.centro;
    return control.touched && control.invalid ? 'Campo requerido' : '';
  }

  onSave(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.saveRequested.emit({
      horas: this.form.controls.horas.getRawValue().trim(),
      centro: this.form.controls.centro.getRawValue().trim(),
    });
  }

  onClose(): void {
    this.closeRequested.emit();
  }

  onDelete(): void {
    this.deleteRequested.emit();
  }

  private patchForm(): void {
    const cell = this.cell;
    this.form.reset(
      {
        incoterms: this.incoterms ?? '',
        comuna: cell?.comuna ?? '',
        pallet: cell ? String(cell.pallet) : '',
        centro: cell?.centro ?? '',
        horas: cell?.horas ?? '',
      },
      { emitEvent: false },
    );
    this.form.markAsUntouched({ emitEvent: false });
    this.cdr.markForCheck();
  }
}
